<template>
    <path d="m19,3l-14,0c-1.1,0 -2,0.9 -2,2l0,14c0,1.101 0.9,2 2,2l7,0l0,-7l-2,0l0,-2.475l2,0l0,-2.05c0,-2.164 1.212,-3.684 3.766,-3.684l1.803,0.002l0,2.605l-1.197,0c-0.994,0 -1.372,0.746 -1.372,1.438l0,1.69l2.568,0l-0.568,2.474l-2,0l0,7l4,0c1.1,0 2,-0.899 2,-2l0,-14c0,-1.1 -0.9,-2 -2,-2z"/>
</template>

<script>
    export default {
        name: 'facebook',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Facebook.vue